import React, { useState, useEffect, useRef, lazy, Suspense, useContext } from 'react';
import { Grid } from '@mui/material';
import { AuthThemeContext } from 'themes/AuthThemeProvider';
import ForgotPasswordWrapper from 'components/ForgotPassword';
import FooterWrapper from 'components/Footer';
import SignInService from 'services/SignInService';
import Loading from 'components/Loading';
import useQueryParams from 'hooks/useQueryParams';

const ForgotPassword = () => {
    const initializedRef = useRef(false);
    const [loginConfig, setLoginConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const { setAppTheme } = useContext(AuthThemeContext);
    const { getQueryParamByName } = useQueryParams();

    useEffect(() => {
        const fetchData = async() => {
            setLoading(!initializedRef.current);
            const returnUrl = getQueryParamByName('ReturnUrl');

            var config = await SignInService.getLogInConfig(returnUrl);
            setLoginConfig(config);
            setAppTheme(config.themeName);
            document.title = config.documentTitle;
            setLoading(false);
            initializedRef.current = true;
        };

        fetchData();

    }, [setAppTheme, getQueryParamByName]);

    const PublicHeaderComponent = ({ componentName, ...props }) => {
        const DynamicComponent = lazy(() => import(`components/${componentName}`));

        return (
            <Suspense fallback={<Loading />}>
                <DynamicComponent {...props} />
            </Suspense>
        );
    }

    return (
        <section>
            {loading === true ?
                <Loading />
            :
                <React.Fragment>
                    {loginConfig && loginConfig.publicHeaderComponent && loginConfig.formType === 'web' ?
                        <PublicHeaderComponent componentName={loginConfig.publicHeaderComponent} title={loginConfig.documentTitle} />
                    : ''}
                    {loginConfig && loginConfig.formType === 'web' ?
                        <React.Fragment>
                            <Grid container alignItems="center" justifyContent="center">
                                <Grid item xs={12}>
                                    <Grid container alignItems="center" justifyContent="center" direction="column">
                                        <Grid item>
                                            <ForgotPasswordWrapper search={window.location.search} loginConfig={loginConfig} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <FooterWrapper />
                        </React.Fragment>
                    :
                        <Grid container alignItems="center" justifyContent="center" direction="column">
                            <Grid item xs={12}>
                                <ForgotPasswordWrapper search={window.location.search} loginConfig={loginConfig} />
                            </Grid>
                        </Grid>
                    }
                </React.Fragment>
            }
        </section>
    );
};

export default ForgotPassword;